import { CommonModule } from '@angular/common';
import type { AfterViewInit } from '@angular/core';
import { Component, inject, output, viewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { IonMenu, IonNav } from '@ionic/angular/standalone';
import type { MenuCloseEventDetail } from '@ionic/core/components';
import { Store } from '@ngrx/store';

import { GeneralActions } from '../../shared/redux/general/general.actions';
import { IonNavService } from '../../shared/services/ion-nav.service';

import { MenuRootComponent } from './menu-root/menu-root.component';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: true,
  imports: [IonNav, CommonModule, RouterModule, IonMenu],
})
export class MenuComponent implements AfterViewInit {
  // UI access
  ionNav = viewChild.required<IonNav>(IonNav);

  // outputs
  menuWillOpen = output<void>();

  // services
  private readonly store = inject(Store);
  private readonly ionNavService = inject(IonNavService);

  root = MenuRootComponent;

  ngAfterViewInit(): void {
    // Initialize the IonNav service after the view has been initialized
    // This ensures the IonNav component is ready to be used
    this.ionNavService.setNav(this.ionNav());
  }

  handleIonDidClose(event: CustomEvent<MenuCloseEventDetail>): void {
    const isPossibleAndroidBackButtonPressed = Capacitor.getPlatform() === 'android' && event.detail.role === undefined;
    if (event.detail.role == 'gesture' || event.detail.role == 'backdrop' || isPossibleAndroidBackButtonPressed) {
      this.handleCloseMenu(true);
    }
  }

  handleIonWillOpen(): void {
    this.menuWillOpen.emit();
  }

  handleCloseMenu(triggeredByGesture: boolean = false): void {
    this.store.dispatch(GeneralActions.closeMenu({ triggeredByGesture }));
  }
}
